<script setup lang="ts">
import Container from '~/components/layout/Container.vue'

const emit = defineEmits<{ subscribe: [] }>();
</script>

<template>
    <Container class="bg-neurodarkgreyvar py-12">
        <div class="flex flex-row overflow-hidden">
            <div class="mr-auto rotate-12 my-auto max-md:hidden">
                <Icon size="250px" name="iconoir:mail-in" class="text-white" />
            </div>
            <div class="my-auto text-right">
                <h3 class="text-3xl font-bold text-white uppercase">Subscribe to our newsletter</h3>
                <h5 class="text-white opacity-50 pb-24">Stay up to date with the most important Neuronoir developments.</h5>
                <button type="button" @click="emit('subscribe')"
                   class="px-10 py-3 bg-neurolight inline-block text-neurodarkgrey opacity-70 rounded">
                    Subscribe
                </button>
            </div>
        </div>
    </Container>
</template>
